const b = (o) => o.split("-")[1], l = ({ state: o, mapId: c, layerGroupId: r }) => {
  var d, i, P, f, I, u, x, T;
  const g = /* @__PURE__ */ new Set([
    "tta",
    "walk_time",
    "drive_time",
    "distance_in_miles",
    "chain-venues",
    "tags"
  ]), s = ((i = (d = o.maps) == null ? void 0 : d[c]) == null ? void 0 : i.layerGroupConfig) || {}, h = ((f = (P = o.maps) == null ? void 0 : P[c]) == null ? void 0 : f.combinedLayersData) || {};
  if (r) {
    const t = (I = h[r]) == null ? void 0 : I.type, e = s[r], n = e == null ? void 0 : e.renderType;
    if (t === "chain") {
      const a = Object.values(
        s[r].subLayerConfig
      ).find((p) => p.renderType === "chain-venues" && p.visualFilter.palette);
      if (a) {
        const p = b(
          a.visualFilter.palette.paletteName
        );
        return parseInt(p) - 1;
      }
    }
    if (n === "tags" && e) {
      const p = ((u = e.visualFilter) == null ? void 0 : u.visualizationType) === "pin" ? (x = e.visualFilter) == null ? void 0 : x.pinPalette : (T = e.visualFilter) == null ? void 0 : T.palette;
      if (p) {
        const C = b(p.paletteName);
        return parseInt(C) - 1;
      }
    }
  }
  const m = Object.entries(
    s
  ).map(([t, e]) => ({
    layerGroupId: t,
    ...e
  })), O = m.map(({ layerGroupId: t, subLayerConfig: e }) => e ? Object.entries(e).map(([n, a]) => ({
    layerGroupId: t,
    subLayerId: n,
    ...a
  })) : []).flat(), y = [...m, ...O].filter(
    ({ renderType: t, visualFilter: e }) => g.has(t) && ((e == null ? void 0 : e.palette) || (e == null ? void 0 : e.pinPalette))
  ).map(({ visualFilter: t }) => {
    var e, n, a;
    return (e = t == null ? void 0 : t.palette) != null && e.paletteName ? (n = t == null ? void 0 : t.palette) == null ? void 0 : n.paletteName.split("-")[1] : (a = t == null ? void 0 : t.pinPalette) == null ? void 0 : a.paletteName.split("-")[1];
  }).sort().reduce(
    (t, e) => {
      const n = parseInt(e);
      return {
        ...t,
        [n]: t[n] + 1
      };
    },
    {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0
    }
  ), N = Object.values(y), L = Math.min(...N), [j] = Object.entries(y).filter(([, t]) => t === L)[0];
  return parseInt(j) - 1;
};
export {
  l as getPOIPaletteIndex
};
//# sourceMappingURL=index.es62.js.map
